import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../api';

const AssetsDropdown = ({ value, onChange }) => {
  const [assets, setAssets] = useState([]);

  useEffect(() => {
    const fetchAssets = async () => {
      try {
        const response = await axiosInstance.get('/assets');
        const data = response.data?.data || response.data || [];
        setAssets(data);
      } catch (error) {
        console.error('Error fetching assets:', error);
      }
    };

    fetchAssets();
  }, []);

  return (
<select
  className="form-select"
  value={value}
  onChange={(e) => onChange(parseInt(e.target.value, 10))}
  required
>
      <option value="">Select Asset</option>
      {assets.map((a) => (
        <option key={a.id} value={a.id}>
          {a.assets_name}
        </option>
      ))}
    </select>
  );
};

export default AssetsDropdown;
